import React, {Component} from 'react';
import PropTypes from 'prop-types';

class AddFeedbackForm extends Component {
    static propTypes = {
        saveCallToAction: PropTypes.string.isRequired,
        handleCancel: PropTypes.func.isRequired,
        handleSave: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
    }

    saveHandler = (event) => {
        const {handleSave} = this.props;
        event.preventDefault();
        handleSave(this.state.value);
    };

    handleChange = (event) => {
        this.setState({value: event.target.value});
    };

    render() {
        const {handleCancel, saveCallToAction} = this.props;
        return (
            <div className="add-comment-form">
                <textarea
                    className="comment-section"
                    value={this.state.value}
                    onChange={this.handleChange}
                />
                <button className="cancel-button" onClick={handleCancel}>
                    X
                </button>
                <button className="save-note" onClick={this.saveHandler}>
                    {saveCallToAction}
                </button>
            </div>
        );
    }
}

const StatusTimelineItem = ({caption, status, className}) => (
    <div className={`timeline-node ${className || ''}`}>
        <div className={`timeline-icon ${status}`} />
        <div className="timeline-caption">{caption}</div>
    </div>
);

StatusTimelineItem.propTypes = {
    caption: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['pending', 'approved', 'rejected', 'blocked', 'link']).isRequired
};

export {AddFeedbackForm, StatusTimelineItem};



// WEBPACK FOOTER //
// ./approval_queues/components/content_review/list_view/content_row/helpers.js